"use strict";
/**
 * APITable <https://github.com/apitable/apitable>
 * Copyright (C) 2022 APITable Ltd. <https://apitable.com>
 *
 * This program is free software: you can redistribute it and/or modify
 * it under the terms of the GNU Affero General Public License as published by
 * the Free Software Foundation, either version 3 of the License, or
 * (at your option) any later version.
 *
 * This program is distributed in the hope that it will be useful,
 * but WITHOUT ANY WARRANTY; without even the implied warranty of
 * MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
 * GNU Affero General Public License for more details.
 *
 * You should have received a copy of the GNU Affero General Public License
 * along with this program.  If not, see <http://www.gnu.org/licenses/>.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EmailCodeType = exports.CodeTypes = exports.SmsTypes = exports.GENERAL_VALIDATION = exports.CHANGE_MAIN_ADMIN = exports.DEL_SPACE = exports.MODIFY_EMAIL = exports.UNBIND_MOBILE = exports.BIND_MOBILE = exports.BIND_DINGDING = exports.MODIFY_PASSWORD = exports.LOGIN_ACCOUNT = exports.REGISTER_ACCOUNT = exports.MOUSE_LEFT_CLICK = exports.TAB_ITEM_WIDTH = exports.TAB_ARROW_RIGHT = exports.TAB_ARROW_LEFT = exports.BREAD_CRUMB_SCROLL_DIST = exports.NODE_DESCRIPTION_EDITOR_ID = exports.ContextMenuType = exports.Modules = exports.UnitTypes = exports.RolePriority = exports.FolderPermissionTip = exports.DashboardPermissionTip = exports.DatasheetPermissionTip = exports.FormPermissionTip = exports.permissionText = exports.nodePermissionMap = exports.permission = exports.Role = exports.EXPORT_TYPE_CSV = exports.EXPORT_TYPE_XLSX = exports.EXPORT_ALL_SHEET_NAME = exports.WorkbenchSidePanels = exports.NODE_CONTEXT_MENU_ID = exports.SocialType = exports.NodeTypeReg = exports.orderedNode = exports.nodeNameMap = exports.NodeType = exports.CELL_EMOJI_LARGE_SIZE = exports.CELL_EMOJI_SIZE = exports.GIRD_CELL_EDITOR = exports.BOTTOM_RIGHT_REGION = exports.UPPER_RIGHT_REGION = exports.BOTTOM_LEFT_REGION = exports.UPPER_LEFT_REGION = exports.FIRST_FILE_IN_GUIDE_CLASS = exports.MAX_ROBOT_COUNT_PER_DST = void 0;
exports.MOBILE_APP_UA = exports.AuthReference = exports.nvcAppkey = exports.PlatFormTypes = exports.ShowRecordHistory = exports.ActivityListParamsType = exports.WIDGET_PANEL_MAX_WIDGET_COUNT = exports.WizardIdConstant = exports.MAX_CHECK_TIMES = exports.PINT_TIMEOUT = exports.BannerType = exports.TEMPLATE_UNCATEGORIZED = exports.TEMPLATE_NAME_MAX = exports.TEMPLATE_CHOICE_CATEGORY_ID = exports.NOTICE_LIST_SIZE = exports.PermissionCode = exports.LS_DATASHEET_NAMESPACE = exports.ACCEPT_FILE_TYPE = exports.ORDER_UPDATE_TIME = exports.ORDER_CREATE_TIME = exports.SORT_ASC = exports.SORT_DESC = exports.USER_INTEGRAL_RECORDS_PAGE_SIZE = exports.MEMBER_NAME_LENGTH = exports.WECHAT = exports.DINGDING = exports.CAPACITY_REWARD_LIST_PAGE_SIZE = exports.SUB_ADMIN_LIST_PAGE_SIZE = exports.MEMBER_LIST_PAGE_SIZE = exports.SPACE_NAME_LENGTH = exports.ROOT_TEAM_ID = exports.PROGRESS_EXCEPTION = exports.PROGRESS_NORMAL = exports.GLASS_FILTER = exports.RESET_PWD_STEP_FINISH = exports.RESET_PWD_STEP_SET_PASSWORD = exports.RESET_PWD_STEP_VERITY_IDENTITY = exports.RESET_PWD_STEP_SELECT_MODE = exports.RESET_PWD_BY_EMAIL = exports.RESET_PWD_BY_PHONE = exports.PASSWORD_MAX_LENGTH = exports.PASSWORD_MIN_LENGTH = exports.SSO_LOGIN = exports.PASSWORD_LOGIN = exports.IDENTIFY_CODE_LOGIN = exports.ImproveType = exports.ScanQrType = exports.LoginTypes = exports.LoginMode = exports.CaptchaIds = void 0;
exports.MAX_URL_COPY_RECOG_NUM = exports.DefaultStatusMessage = exports.JSBridgeMethod = void 0;
const env_1 = require("../config/env");
const i18n_1 = require("../exports/i18n");
exports.MAX_ROBOT_COUNT_PER_DST = 30; // The maximum number of robots in a single table
// When you click the file for the first time, to activate the novice guide, you need to add a class
exports.FIRST_FILE_IN_GUIDE_CLASS = 'FIRST_FILE_IN_GUIDE_CLASS';
// table area related
exports.UPPER_LEFT_REGION = 0;
exports.BOTTOM_LEFT_REGION = 1;
exports.UPPER_RIGHT_REGION = 2;
exports.BOTTOM_RIGHT_REGION = 3;
exports.GIRD_CELL_EDITOR = 'gridCellEditor';
exports.CELL_EMOJI_SIZE = 16;
exports.CELL_EMOJI_LARGE_SIZE = 22;
// Node type (please +1 the value when adding a new type)
var NodeType;
(function (NodeType) {
    NodeType[NodeType["ROOT"] = 0] = "ROOT";
    NodeType[NodeType["FOLDER"] = 1] = "FOLDER";
    NodeType[NodeType["DATASHEET"] = 2] = "DATASHEET";
    NodeType[NodeType["FORM"] = 3] = "FORM";
    NodeType[NodeType["DASHBOARD"] = 4] = "DASHBOARD";
    NodeType[NodeType["MIRROR"] = 5] = "MIRROR";
    NodeType[NodeType["DATAPAGE"] = 6] = "DATAPAGE";
    NodeType[NodeType["CANVAS"] = 7] = "CANVAS";
    NodeType[NodeType["WORD_DOC"] = 8] = "WORD_DOC";
    NodeType[NodeType["VIEW"] = 9] = "VIEW";
    NodeType[NodeType["ASSET_FILE"] = 98] = "ASSET_FILE";
    NodeType[NodeType["TRASH"] = 99] = "TRASH";
})(NodeType = exports.NodeType || (exports.NodeType = {}));
exports.nodeNameMap = new Map([
    [NodeType.FOLDER, (0, i18n_1.t)(i18n_1.Strings.folder)],
    [NodeType.DATASHEET, (0, i18n_1.t)(i18n_1.Strings.datasheet)],
    [NodeType.FORM, (0, i18n_1.t)(i18n_1.Strings.form)],
    [NodeType.VIEW, (0, i18n_1.t)(i18n_1.Strings.view)],
    [NodeType.TRASH, (0, i18n_1.t)(i18n_1.Strings.trash)],
    [NodeType.MIRROR, (0, i18n_1.t)(i18n_1.Strings.mirror)],
    [NodeType.DASHBOARD, (0, i18n_1.t)(i18n_1.Strings.dashboard)],
]);
exports.orderedNode = [
    {
        type: NodeType.FOLDER,
        name: (0, i18n_1.t)(i18n_1.Strings.folder),
    },
    {
        type: NodeType.DATASHEET,
        name: (0, i18n_1.t)(i18n_1.Strings.file),
    },
    {
        type: NodeType.FORM,
        name: (0, i18n_1.t)(i18n_1.Strings.view_form),
    },
    {
        type: NodeType.DASHBOARD,
        name: (0, i18n_1.t)(i18n_1.Strings.dashboard),
    },
];
var NodeTypeReg;
(function (NodeTypeReg) {
    NodeTypeReg["FOLDER"] = "fod";
    NodeTypeReg["DATASHEET"] = "dst";
    NodeTypeReg["FORM"] = "fom";
    NodeTypeReg["DASHBOARD"] = "dsb";
    NodeTypeReg["MIRROR"] = "mir";
    NodeTypeReg["WIDGET"] = "wdt";
})(NodeTypeReg = exports.NodeTypeReg || (exports.NodeTypeReg = {}));
var SocialType;
(function (SocialType) {
    SocialType[SocialType["WECOM"] = 1] = "WECOM";
    SocialType[SocialType["DINGTALK"] = 2] = "DINGTALK";
    SocialType[SocialType["FEISHU"] = 3] = "FEISHU";
    SocialType[SocialType["WOA"] = 10] = "WOA";
})(SocialType = exports.SocialType || (exports.SocialType = {}));
// catalog tree
exports.NODE_CONTEXT_MENU_ID = 'NODE_CONTEXT_MENU_ID';
var WorkbenchSidePanels;
(function (WorkbenchSidePanels) {
    WorkbenchSidePanels[WorkbenchSidePanels["FAVORITE"] = 0] = "FAVORITE";
    WorkbenchSidePanels[WorkbenchSidePanels["CATALOG"] = 1] = "CATALOG";
})(WorkbenchSidePanels = exports.WorkbenchSidePanels || (exports.WorkbenchSidePanels = {}));
exports.EXPORT_ALL_SHEET_NAME = (0, i18n_1.t)(i18n_1.Strings.form_the_full);
exports.EXPORT_TYPE_XLSX = 'xlsx';
exports.EXPORT_TYPE_CSV = 'csv';
var Role;
(function (Role) {
    Role["Administrator"] = "administrator";
    Role["Manager"] = "manager";
    Role["Editor"] = "editor";
    Role["Reader"] = "reader";
    Role["None"] = "none";
    Role["Member"] = "member";
    Role["Guest"] = "guest";
    Role["Foreigner"] = "foreigner";
})(Role = exports.Role || (exports.Role = {}));
exports.permission = {
    manager: 'manager',
    editor: 'editor',
    reader: 'reader',
    updater: 'updater',
    templateVisitor: 'templateVisitor',
    owner: 'manager',
    anonymous: 'reader',
    foreigner: 'reader',
    // for share
    shareReader: 'shareReader',
    shareEditor: 'shareEditor',
    shareSave: 'shareSave',
};
exports.nodePermissionMap = new Map([
    [
        NodeType.DATASHEET,
        {
            [exports.permission.manager]: (0, i18n_1.t)(i18n_1.Strings.add_datasheet_manager),
            [exports.permission.editor]: (0, i18n_1.t)(i18n_1.Strings.add_datasheet_editor),
            [exports.permission.reader]: (0, i18n_1.t)(i18n_1.Strings.add_datasheet_reader),
            [exports.permission.updater]: (0, i18n_1.t)(i18n_1.Strings.add_datasheet_updater),
        },
    ],
    [
        NodeType.FOLDER,
        {
            [exports.permission.manager]: (0, i18n_1.t)(i18n_1.Strings.add_folder_manager),
            [exports.permission.editor]: (0, i18n_1.t)(i18n_1.Strings.add_folder_editor),
            [exports.permission.reader]: (0, i18n_1.t)(i18n_1.Strings.add_folder_reader),
            [exports.permission.updater]: (0, i18n_1.t)(i18n_1.Strings.add_folder_updater),
        },
    ],
    [
        NodeType.FORM,
        {
            [exports.permission.manager]: (0, i18n_1.t)(i18n_1.Strings.form_manager_label),
            [exports.permission.editor]: (0, i18n_1.t)(i18n_1.Strings.form_editor_label),
            [exports.permission.reader]: (0, i18n_1.t)(i18n_1.Strings.form_reader_label),
            [exports.permission.updater]: (0, i18n_1.t)(i18n_1.Strings.form_updater_label),
        },
    ],
    [
        NodeType.DASHBOARD,
        {
            [exports.permission.manager]: (0, i18n_1.t)(i18n_1.Strings.dashboard_manager_label),
            [exports.permission.editor]: (0, i18n_1.t)(i18n_1.Strings.dashboard_editor_label),
            [exports.permission.reader]: (0, i18n_1.t)(i18n_1.Strings.dashboard_reader_label),
            [exports.permission.updater]: (0, i18n_1.t)(i18n_1.Strings.dashboard_updater_label),
        },
    ],
    [
        NodeType.MIRROR,
        {
            [exports.permission.manager]: (0, i18n_1.t)(i18n_1.Strings.mirror_manager_label),
            [exports.permission.editor]: (0, i18n_1.t)(i18n_1.Strings.mirror_editor_label),
            [exports.permission.reader]: (0, i18n_1.t)(i18n_1.Strings.mirror_reader_label),
            [exports.permission.updater]: (0, i18n_1.t)(i18n_1.Strings.mirror_uploader_label),
        },
    ],
]);
exports.permissionText = {
    manager: (0, i18n_1.t)(i18n_1.Strings.can_control),
    editor: (0, i18n_1.t)(i18n_1.Strings.can_edit),
    reader: (0, i18n_1.t)(i18n_1.Strings.can_read),
    member: (0, i18n_1.t)(i18n_1.Strings.ordinary_members),
    updater: (0, i18n_1.t)(i18n_1.Strings.can_updater),
    templateVisitor: (0, i18n_1.t)(i18n_1.Strings.permission_template_visitor),
    shareReader: (0, i18n_1.t)(i18n_1.Strings.share_reader),
    shareEditor: (0, i18n_1.t)(i18n_1.Strings.share_editor),
    shareSave: (0, i18n_1.t)(i18n_1.Strings.share_save),
};
exports.FormPermissionTip = {
    manager: (0, i18n_1.t)(i18n_1.Strings.form_manager_label),
    editor: (0, i18n_1.t)(i18n_1.Strings.form_editor_label),
    reader: (0, i18n_1.t)(i18n_1.Strings.form_reader_label),
};
exports.DatasheetPermissionTip = {
    manager: (0, i18n_1.t)(i18n_1.Strings.datasheet_manager_label),
    editor: (0, i18n_1.t)(i18n_1.Strings.datasheet_editor_label),
    reader: (0, i18n_1.t)(i18n_1.Strings.datasheet_reader_label),
    templateVisitor: (0, i18n_1.t)(i18n_1.Strings.datasheet_experience_label),
    shareReader: (0, i18n_1.t)(i18n_1.Strings.share_reader_label),
    shareEditor: (0, i18n_1.t)(i18n_1.Strings.share_editor_label),
    shareSave: (0, i18n_1.t)(i18n_1.Strings.share_save_label),
};
exports.DashboardPermissionTip = {
    manager: (0, i18n_1.t)(i18n_1.Strings.dashboard_manager_label),
    editor: (0, i18n_1.t)(i18n_1.Strings.dashboard_editor_label),
    reader: (0, i18n_1.t)(i18n_1.Strings.dashboard_reader_label),
    // templateVisitor this can be shared
    templateVisitor: (0, i18n_1.t)(i18n_1.Strings.datasheet_experience_label),
    shareReader: (0, i18n_1.t)(i18n_1.Strings.share_reader_label),
    shareEditor: (0, i18n_1.t)(i18n_1.Strings.share_editor_label),
    shareSave: (0, i18n_1.t)(i18n_1.Strings.share_save_label),
};
exports.FolderPermissionTip = {
    manager: (0, i18n_1.t)(i18n_1.Strings.folder_manager_label),
    editor: (0, i18n_1.t)(i18n_1.Strings.folder_editor_label),
    reader: (0, i18n_1.t)(i18n_1.Strings.folder_reader_label),
    templateVisitor: (0, i18n_1.t)(i18n_1.Strings.datasheet_experience_label),
};
// TODO(remove eslint disable)
var RolePriority;
(function (RolePriority) {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    RolePriority[RolePriority["manager"] = 0] = "manager";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    RolePriority[RolePriority["editor"] = 1] = "editor";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    RolePriority[RolePriority["reader"] = 2] = "reader";
    // eslint-disable-next-line @typescript-eslint/naming-convention
    RolePriority[RolePriority["updater"] = 3] = "updater";
})(RolePriority = exports.RolePriority || (exports.RolePriority = {}));
var UnitTypes;
(function (UnitTypes) {
    UnitTypes["Teams"] = "teams";
    UnitTypes["Tags"] = "tags";
    UnitTypes["Members"] = "members";
})(UnitTypes = exports.UnitTypes || (exports.UnitTypes = {}));
/** Indicates the module where the menu is located */
var Modules;
(function (Modules) {
    Modules["FAVORITE"] = "FAVORITE";
    Modules["CATALOG"] = "CATALOG";
    Modules["SHARE"] = "SHARE";
    Modules["TEAM_TREE"] = "TEAM_TREE";
})(Modules = exports.Modules || (exports.Modules = {}));
/** Indicates the type of menu, each different type of menu corresponds to a different menu list */
var ContextMenuType;
(function (ContextMenuType) {
    ContextMenuType["DEFAULT"] = "DEFAULT";
    ContextMenuType["DATASHEET"] = "DATASHEET";
    ContextMenuType["FORM"] = "FORM";
    ContextMenuType["DASHBOARD"] = "DASHBOARD";
    ContextMenuType["FOLDER"] = "FOLDER";
    ContextMenuType["FOLDER_SHOWCASE"] = "FOLDER_SHOWCASE";
    ContextMenuType["VIEW_TABBAR"] = "VIEW_TABBAR";
    ContextMenuType["MIRROR"] = "MIRROR";
    ContextMenuType["FORM_FIELD_OP"] = "FORM_FIELD_OP";
    ContextMenuType["EXPAND_RECORD_FIELD"] = "EXPAND_RECORD_FIELD";
})(ContextMenuType = exports.ContextMenuType || (exports.ContextMenuType = {}));
exports.NODE_DESCRIPTION_EDITOR_ID = 'folderDescribeEditor';
exports.BREAD_CRUMB_SCROLL_DIST = 100;
// tabbar
exports.TAB_ARROW_LEFT = 'left';
exports.TAB_ARROW_RIGHT = 'right';
exports.TAB_ITEM_WIDTH = 180;
exports.MOUSE_LEFT_CLICK = 0;
// login/register
exports.REGISTER_ACCOUNT = 1;
exports.LOGIN_ACCOUNT = 2;
exports.MODIFY_PASSWORD = 3;
exports.BIND_DINGDING = 4;
exports.BIND_MOBILE = 5;
exports.UNBIND_MOBILE = 6;
exports.MODIFY_EMAIL = 7;
exports.DEL_SPACE = 8;
exports.CHANGE_MAIN_ADMIN = 9;
exports.GENERAL_VALIDATION = 10;
var SmsTypes;
(function (SmsTypes) {
    SmsTypes[SmsTypes["REGISTER_ACCOUNT"] = 1] = "REGISTER_ACCOUNT";
    SmsTypes[SmsTypes["LOGIN_ACCOUNT"] = 2] = "LOGIN_ACCOUNT";
    SmsTypes[SmsTypes["MODIFY_PASSWORD"] = 3] = "MODIFY_PASSWORD";
    SmsTypes[SmsTypes["BIND_DINGDING"] = 4] = "BIND_DINGDING";
    SmsTypes[SmsTypes["BIND_MOBILE"] = 5] = "BIND_MOBILE";
    SmsTypes[SmsTypes["UNBIND_MOBILE"] = 6] = "UNBIND_MOBILE";
    SmsTypes[SmsTypes["MODIFY_EMAIL"] = 7] = "MODIFY_EMAIL";
    SmsTypes[SmsTypes["DEL_SPACE"] = 8] = "DEL_SPACE";
    SmsTypes[SmsTypes["CHANGE_MAIN_ADMIN"] = 9] = "CHANGE_MAIN_ADMIN";
    SmsTypes[SmsTypes["GENERAL_VALIDATION"] = 10] = "GENERAL_VALIDATION";
    SmsTypes[SmsTypes["CHANGE_DEVELOPER_CONFIG"] = 11] = "CHANGE_DEVELOPER_CONFIG";
    SmsTypes[SmsTypes["BIND_SOCIAL_USER"] = 12] = "BIND_SOCIAL_USER";
})(SmsTypes = exports.SmsTypes || (exports.SmsTypes = {}));
var CodeTypes;
(function (CodeTypes) {
    CodeTypes["SMS_CODE"] = "sms_code";
    CodeTypes["EMAIL_CODE"] = "email_code";
})(CodeTypes = exports.CodeTypes || (exports.CodeTypes = {}));
var EmailCodeType;
(function (EmailCodeType) {
    EmailCodeType[EmailCodeType["BIND"] = 1] = "BIND";
    EmailCodeType[EmailCodeType["REGISTER"] = 2] = "REGISTER";
    EmailCodeType[EmailCodeType["COMMON"] = 3] = "COMMON";
})(EmailCodeType = exports.EmailCodeType || (exports.EmailCodeType = {}));
var CaptchaIds;
(function (CaptchaIds) {
    CaptchaIds["LOGIN"] = "login";
    CaptchaIds["DEFAULT"] = "nc";
})(CaptchaIds = exports.CaptchaIds || (exports.CaptchaIds = {}));
var LoginMode;
(function (LoginMode) {
    LoginMode["PASSWORD"] = "password";
    LoginMode["IDENTIFYING_CODE"] = "identifying_code";
    LoginMode["MAIL"] = "mail";
    LoginMode["PHONE"] = "phone";
    LoginMode["OTHER"] = "other";
})(LoginMode = exports.LoginMode || (exports.LoginMode = {}));
var LoginTypes;
(function (LoginTypes) {
    LoginTypes["SMS"] = "sms_code";
    LoginTypes["EMAIL"] = "email_code";
    LoginTypes["PASSWORD"] = "password";
    LoginTypes["SSO_AUTH"] = "sso_auth";
})(LoginTypes = exports.LoginTypes || (exports.LoginTypes = {}));
// Scan QRCode operations
var ScanQrType;
(function (ScanQrType) {
    ScanQrType[ScanQrType["Login"] = 0] = "Login";
    ScanQrType[ScanQrType["Binding"] = 1] = "Binding";
})(ScanQrType = exports.ScanQrType || (exports.ScanQrType = {}));
var ImproveType;
(function (ImproveType) {
    ImproveType["Phone"] = "phone";
    ImproveType["Email"] = "email";
})(ImproveType = exports.ImproveType || (exports.ImproveType = {}));
exports.IDENTIFY_CODE_LOGIN = 'identify_code_login'; // login verify code
exports.PASSWORD_LOGIN = 'password_login'; // password login
exports.SSO_LOGIN = 'sso_login'; // sso login
exports.PASSWORD_MIN_LENGTH = 8;
exports.PASSWORD_MAX_LENGTH = 24;
// export const PASSWORD_LENGTH_ERR = t(Strings.password_length_err); // 'Password length must be between 8-24';
// export const PASSWORD_PATTERN_ERR = t(Strings.password_pattern_err); // 'Password must contain both numbers and letters';
// export const PASSWORD_NOT_IDENTICAL_ERR = t(Strings.password_not_identical_err); // 'different from the first entered password';
// export const PHONE_ERR = t(Strings.phone_err); // 'The phone number format is incorrect';
// export const EMAIL_ERR = t(Strings.email_err); // 'The email format is incorrect';
// export const BIND_PHONE_SAME = t(Strings.bind_phone_same); // 'Cannot change to the same phone number';
// export const BIND_EMAIL_SAME = t(Strings.bind_email_same); // 'Cannot change to the same email';
// export const PHONE_CODE_ERR = t(Strings.phone_code_err); // 'Verification code error';
exports.RESET_PWD_BY_PHONE = 0;
exports.RESET_PWD_BY_EMAIL = 1;
exports.RESET_PWD_STEP_SELECT_MODE = 0;
exports.RESET_PWD_STEP_VERITY_IDENTITY = 1;
exports.RESET_PWD_STEP_SET_PASSWORD = 2;
exports.RESET_PWD_STEP_FINISH = 3;
exports.GLASS_FILTER = 'blur(8px)';
exports.PROGRESS_NORMAL = 'normal';
exports.PROGRESS_EXCEPTION = 'exception';
// space - basic space information
exports.ROOT_TEAM_ID = '0';
exports.SPACE_NAME_LENGTH = 100;
// space-members-members list query pages number
exports.MEMBER_LIST_PAGE_SIZE = 13;
// space - sub admin - sub admin list query pages number
exports.SUB_ADMIN_LIST_PAGE_SIZE = 12;
// gifted space query page number
exports.CAPACITY_REWARD_LIST_PAGE_SIZE = 12;
// personal center
exports.DINGDING = 0;
exports.WECHAT = 1;
exports.MEMBER_NAME_LENGTH = 32; // space nickname length cannot exceed 32 characters
exports.USER_INTEGRAL_RECORDS_PAGE_SIZE = 4; // account wallet orders number per page
// data sorting rule
exports.SORT_DESC = 'desc';
exports.SORT_ASC = 'asc';
exports.ORDER_CREATE_TIME = 'createdAt';
exports.ORDER_UPDATE_TIME = 'updatedAt';
// personal avatar relates to space log
// attributes can not use short name, https://blog.csdn.net/weixin_45936690/article/details/108386544
exports.ACCEPT_FILE_TYPE = 'image/jpeg,image/png,image/gif';
// localStorage 's namespace
// https://github.com/nbubna/store
exports.LS_DATASHEET_NAMESPACE = '_datasheet';
// operation permission id
var PermissionCode;
(function (PermissionCode) {
    PermissionCode["WORKBENCH"] = "MANAGE_WORKBENCH";
    PermissionCode["TEAM"] = "MANAGE_TEAM";
    PermissionCode["MEMBER"] = "MANAGE_MEMBER";
    PermissionCode["NORMAL_MEMBER"] = "MANAGE_NORMAL_MEMBER";
    PermissionCode["TEMPLATE"] = "MANAGE_TEMPLATE";
    PermissionCode["MANAGE_WIDGET"] = "MANAGE_WIDGET";
    PermissionCode["SECURITY"] = "MANAGE_SECURITY";
    PermissionCode["MANAGE_ROLE"] = "MANAGE_ROLE";
})(PermissionCode = exports.PermissionCode || (exports.PermissionCode = {}));
// notification center
exports.NOTICE_LIST_SIZE = 10; // notification list, one request notification count
// template center
exports.TEMPLATE_CHOICE_CATEGORY_ID = 'tpc000';
exports.TEMPLATE_NAME_MAX = 100;
exports.TEMPLATE_UNCATEGORIZED = 'tpc_uncategorized';
var BannerType;
(function (BannerType) {
    BannerType["LARGE"] = "large";
    BannerType["MIDDLE"] = "middle";
})(BannerType = exports.BannerType || (exports.BannerType = {}));
// the timeout of socket ping, actually 120000+25000
exports.PINT_TIMEOUT = 150000;
// max check times
exports.MAX_CHECK_TIMES = 10;
// export const NODE_INTRODUCE_MAP = new Map([
//   [
//     NodeType.FORM,
//     {
//       title: t(Strings.form_view),
//       desc: t(Strings.form_view_desc),
//       videoGuide: integrateCdnHost(Settings.form_guide_video.value),
//     },
//   ],
// ]);
// wizardId
var WizardIdConstant;
(function (WizardIdConstant) {
    WizardIdConstant[WizardIdConstant["EMAIL_BIND"] = 20] = "EMAIL_BIND";
    WizardIdConstant[WizardIdConstant["INTRODUCTION_VIDEO_14_SERVER"] = 24] = "INTRODUCTION_VIDEO_14_SERVER";
    WizardIdConstant[WizardIdConstant["FUNCTION_GUIDANCE"] = 18] = "FUNCTION_GUIDANCE";
    WizardIdConstant[WizardIdConstant["REPLAY_GANTT_VIDEO"] = 34] = "REPLAY_GANTT_VIDEO";
    WizardIdConstant[WizardIdConstant["REPLAY_CALENDAR_VIDEO"] = 37] = "REPLAY_CALENDAR_VIDEO";
    WizardIdConstant[WizardIdConstant["REPLAY_ORG_CHART_VIDEO"] = 54] = "REPLAY_ORG_CHART_VIDEO";
    WizardIdConstant[WizardIdConstant["ADD_FIRST_CHILD"] = 57] = "ADD_FIRST_CHILD";
    WizardIdConstant[WizardIdConstant["DRAG_TO_UNHANDLED_LIST"] = 58] = "DRAG_TO_UNHANDLED_LIST";
    WizardIdConstant[WizardIdConstant["CREATE_WIDGET_GUIDE"] = 40] = "CREATE_WIDGET_GUIDE";
    WizardIdConstant[WizardIdConstant["RELEASE_WIDGET_GUIDE"] = 47] = "RELEASE_WIDGET_GUIDE";
    WizardIdConstant[WizardIdConstant["CONTACT_US_GUIDE"] = 64] = "CONTACT_US_GUIDE";
    WizardIdConstant[WizardIdConstant["VIKABY_UPDATE_LOGS_HISTORY"] = 67] = "VIKABY_UPDATE_LOGS_HISTORY";
    WizardIdConstant[WizardIdConstant["AGREE_TERMS_OF_SERVICE"] = Number((0, env_1.getCustomConfig)().LOGIN_AGREE_TERMS_OF_SERVICE_WIZARD_ID)] = "AGREE_TERMS_OF_SERVICE";
    // org chart view
    WizardIdConstant[WizardIdConstant["ORG_VIEW_CREATE"] = 78] = "ORG_VIEW_CREATE";
    WizardIdConstant[WizardIdConstant["ORG_VIEW_PANEL"] = 79] = "ORG_VIEW_PANEL";
    WizardIdConstant[WizardIdConstant["ORG_VIEW_ADD_FIRST_NODE"] = 80] = "ORG_VIEW_ADD_FIRST_NODE";
    WizardIdConstant[WizardIdConstant["ORG_VIEW_DRAG_TO_UNHANDLED_LIST"] = 81] = "ORG_VIEW_DRAG_TO_UNHANDLED_LIST";
    // node permissions
    WizardIdConstant[WizardIdConstant["PERMISSION_SETTING_EXTEND"] = 95] = "PERMISSION_SETTING_EXTEND";
    WizardIdConstant[WizardIdConstant["PERMISSION_SETTING_OPENED"] = 96] = "PERMISSION_SETTING_OPENED";
    WizardIdConstant[WizardIdConstant["CREATE_MIRROR_TIP"] = 106] = "CREATE_MIRROR_TIP";
})(WizardIdConstant = exports.WizardIdConstant || (exports.WizardIdConstant = {}));
exports.WIDGET_PANEL_MAX_WIDGET_COUNT = 30;
// 0 => all
// 1 => changelog history
// 2 => comments
var ActivityListParamsType;
(function (ActivityListParamsType) {
    ActivityListParamsType[ActivityListParamsType["ALL"] = 0] = "ALL";
    ActivityListParamsType[ActivityListParamsType["HISTORY"] = 1] = "HISTORY";
    ActivityListParamsType[ActivityListParamsType["COMMENT"] = 2] = "COMMENT";
})(ActivityListParamsType = exports.ActivityListParamsType || (exports.ActivityListParamsType = {}));
var ShowRecordHistory;
(function (ShowRecordHistory) {
    ShowRecordHistory[ShowRecordHistory["CLOSE"] = 0] = "CLOSE";
    ShowRecordHistory[ShowRecordHistory["OPEN"] = 1] = "OPEN";
})(ShowRecordHistory = exports.ShowRecordHistory || (exports.ShowRecordHistory = {}));
// platform information
var PlatFormTypes;
(function (PlatFormTypes) {
    PlatFormTypes["Web"] = "Web";
    PlatFormTypes["Desktop"] = "Desktop";
    PlatFormTypes["App"] = "App";
})(PlatFormTypes = exports.PlatFormTypes || (exports.PlatFormTypes = {}));
// captcha appkey
exports.nvcAppkey = 'FFFF0N00000000008B7D';
// Distinguish the entry source of the jump (Wecom App Store application) authorization page
var AuthReference;
(function (AuthReference) {
    AuthReference["CAMERA"] = "camera";
    AuthReference["APPLICATION"] = "application";
})(AuthReference = exports.AuthReference || (exports.AuthReference = {}));
exports.MOBILE_APP_UA = 'vikaApp';
var JSBridgeMethod;
(function (JSBridgeMethod) {
    JSBridgeMethod["OpenAppFeedback"] = "openAppFeedback";
})(JSBridgeMethod = exports.JSBridgeMethod || (exports.JSBridgeMethod = {}));
var DefaultStatusMessage;
(function (DefaultStatusMessage) {
    DefaultStatusMessage["OK_MSG"] = "SUCCESS";
    DefaultStatusMessage["SERVER_ERROR_MSG"] = "SERVER_ERROR";
})(DefaultStatusMessage = exports.DefaultStatusMessage || (exports.DefaultStatusMessage = {}));
// batch copy URL cell, max support batch recognize count
exports.MAX_URL_COPY_RECOG_NUM = 100;
//# sourceMappingURL=constant.js.map